import axiosClient from "./services";

export async function getRequest(URL) {
  const response = await axiosClient.get(`/v1/api${URL}`);
  return response;
}
